import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { getRCAccountId, getUserData } from "@client/utils";
import style from "./style";
import NotificationForm from "../../shared/notification-form";
import SimulateNotification from "../../shared/simulated-notification";
import DialogActions from "@mui/material/DialogActions";
import { useNavigate, useParams } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";
import CloseIcon from "@mui/icons-material/Close";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import clsx from "clsx";
import { globalStyles } from "@client/shared/constants";

const EditNotificationView = ({
  dialog,
  isSaving,
  notification = {},
  preference,
  userHasChanged,
  values,
  isParsingPhoneNumber,
  isPhoneNumberParsed,
  handleDuplicateClick = () => { },
  handleDeleteConfirmation = () => { },
  updatePreferences = () => { },
  handleDuplicateConfirmation = () => { },
  isSectionComplete = () => { },
  handleFormSubmit = () => { },
  handleDelete = () => { },
  notificationFormOnChange = () => { },
  onParsingPhoneNumber = () => { },
  onPhoneNumParsedSuccess = () => { },
  deleteOnCancel = () => { },
  deleteOnPreferenceChange = () => { },
  duplicateOnCancel = () => { },
  duplicateOnPreferenceChange = () => { },
  duplicateOnClose = () => { },
  DuplicateOnConfirm = () => { },
  handleDuplicateSuccess = () => { },
  countries = [],
  sites = [],
  teams = [],
  users = [],
  loadedTeams = false,
  loadedSites = false,
  loadedUsers = false,
  loadedCountries = false,
  loadedExtension = false,
  toggleOnCancel = () => { },
  toggleOnPreferenceChange = () => { },
  handleToggleConfirmation = () => { },
  handleToggle = () => { },
  onNewTeamCreated = () => { }
}) => {
  const userData = (getUserData() || {}).user || {};
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <Box sx={style.pageHeadingWrapper}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography sx={style.pageHeading} variant="h5">
            Notifications
          </Typography>
          <IconButton disabled>
            <img alt="Right Arrow" src={"/assets/expand-less.svg"} />
          </IconButton>
          <Typography
            sx={{ ...style.pageHeading, color: "black" }}
            variant="h5"
            display="inline"
          >
            {notification?.name || ""}
          </Typography>
        </Box>
        <Typography sx={style.pageHeadingCaption} variant="caption">
          Here you can modify existing notification.
        </Typography>
        <span style={style.pageHeadingMarker}></span>
      </Box>
      <Box sx={{ marginTop: "12px", marginBottom: notification?.enabled ? "8px" : "32px", ...style.headerBtns }}>
        {/* <Button
              color='primary'
              variant='outlined'
              startIcon={<img alt='' src={SimulateIcon} />}
            >
              <Typography variant='button'>Simulate</Typography>
            </Button> */}
        <SimulateNotification
          accountId={getRCAccountId()}
          disabled={notification === null || !notification?.enabled}
          extension={
            notification?.users?.split(",")[0] === "All Users"
              ? userData.extensionId
              : notification?.users?.split(",")[0]
          }
          notification={notification}
        />
        {!notification?.enabled && (
          <Box sx={{ position: 'absolute' }}><Typography variant="caption">Notification is turned off.</Typography></Box>
        )}
        <Button
          sx={{ ml: "32px" }}
          color="primary"
          onClick={handleDuplicateClick}
          variant="outlined"
          startIcon={<img alt="" src={"/assets/duplicate.svg"} />}
        >
          <Typography variant="button">Duplicate</Typography>
        </Button>
        <Button
          sx={{ ml: "32px" }}
          color="error"
          onClick={handleDelete}
          variant="outlined"
          startIcon={<img alt="" src="/assets/trash.svg" />}
        >
          <Typography variant="button">Delete</Typography>
        </Button>
        <FormControlLabel
          control={
            <Switch
              checked={!!notification.enabled}
              sx={{ m: 1 }}
              labelClassName={clsx("p-relative", style.switchLabel)}
              onClick={handleToggle}
            />
          }
          sx={
            !notification?.enabled
              ? {
                "& .MuiFormControlLabel-label": {
                  ...globalStyles.text.color.disabled,
                },
                ml: 2,
              }
              : {
                "& .MuiFormControlLabel-label": {
                  color: "#6258de",
                  fontWeight: "bold",
                },
                ml: 2,
              }
          }
          label={notification?.enabled ? "ON" : "OFF"}
        />
      </Box>
      <NotificationForm
        countries={countries}
        sites={sites}
        teams={teams}
        loadedTeams={loadedTeams}
        loadedSites={loadedSites}
        loadedUsers={loadedUsers}
        loadedCountries={loadedCountries}
        users={users}
        notification={notification}
        onChange={notificationFormOnChange}
        onParsingPhoneNumber={onParsingPhoneNumber}
        onPhoneNumParsedSuccess={onPhoneNumParsedSuccess}
        showAll={true}
        loadedExtension={loadedExtension}
        onNewTeamCreated={onNewTeamCreated}
      />
      <Dialog open={dialog.delete}>
        <DialogContent
          sx={{ maxHeight: "400px", minHeight: "200px", maxWidth: "400px" }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6">Delete Notification?</Typography>
            <IconButton>
              <CloseIcon
                sx={{ color: "grey.600" }}
                fontSize="small"
                onClick={deleteOnCancel}
              />
            </IconButton>
          </Box>
          <Typography variant="subtitle2">
            Are you sure you want to delete this notification? You will not be
            able to recover it after you delete it.
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginTop: "32px",
            }}
          >
            <Checkbox
              checked={preference.delete}
              onChange={deleteOnPreferenceChange}
            />
            <Typography variant="subtitle2">
              Do not show this message again.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={deleteOnCancel}
            sx={{ color: "grey.600", mr: 4 }}
            variant="text"
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleDeleteConfirmation(params.id)}
            variant="contained"
            color="error"
            disabled={dialog.isDeleting}
          >
            {dialog.isDeleting && (
							<CircularProgress size={18} sx={{ position: 'absolute' }} />
						)}
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={dialog.duplicate}>
        <DialogTitle>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h6" sx={{ mt: 1 }}>
              Duplicate Notification?
            </Typography>
            <IconButton>
              <CloseIcon
                sx={{ color: "grey.600" }}
                fontSize="small"
                onClick={duplicateOnCancel}
              />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ minWidth: "400px", maxWidth: "400px", mt: 1 }}>
          <Typography variant="subtitle2">
            Are you sure you want to duplicate this notification? This action
            cannot be undone and you will receive duplicate notifications.
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", mt: 5 }}>
            <Checkbox
              checked={preference.duplicate}
              onChange={duplicateOnPreferenceChange}
            />
            <Typography variant="body1">
              Do not show this message again.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={duplicateOnCancel}
            sx={{ color: "grey.600", mr: 4 }}
            variant="text"
          >
            Cancel
          </Button>
          <Button
            disabled={dialog.isDuplicating}
            onClick={handleDuplicateConfirmation} variant="contained"
          >
            {dialog.isDuplicating && (
							<CircularProgress size={18} sx={{ position: 'absolute' }} />
						)}
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      {/* <ActionDialog
            contentText='Your notification has been duplicated.'
            heading='Notification Duplicated!'
            hasPreferenceCheck
            open={dialog.duplicateSuccess}
            onClose={duplicateOnClose}
            onConfirm={DuplicateOnConfirm}
            onPreferenceChange={handleDuplicateSuccess}
            preferenceChecked={!preference.duplicateSuccess}
          /> */}
      <Dialog open={dialog.duplicateSuccess}>
        <DialogContent>
          <Typography variant="h6">Notification Duplicated!</Typography>
          <Typography variant="subtitle2">
            Your notification has been duplicated.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={DuplicateOnConfirm} variant="contained">
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={dialog.saved}>
        <DialogContent sx={{ minWidth: "320px", minHeight: "140px" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6">Notification Saved!</Typography>
            <IconButton>
              <CloseIcon
                sx={{ color: "grey.600" }}
                fontSize="small"
                onClick={() => {
                  navigate(`/notifications`);
                }}
              />
            </IconButton>
          </Box>

          <Typography variant="subtitle2" sx={{ mt: 2 }}>
            Your notification has been saved.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              navigate(`/notifications`);
            }}
            sx={{ color: "grey.600", mr: 4 }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              navigate(`/notifications`);
            }}
            variant="contained"
            color="secondary"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      {((notification && values) || true) && (
        <Box
          sx={{
            ...style.actions,
            display: "flex",
            justifyContent: "end",
            marginBottom: "16px",
            marginTop: "32px",
          }}
        >
          <Button
            sx={{ ...style.greyAction, marginRight: "16px" }}
            onClick={() => navigate("/notifications")}
            variant="outlined"
          >
            Cancel
          </Button>

          <Button
            sx={{ mr: "16px" }}
            disabled={
              userHasChanged
                ? isSaving || !isSectionComplete() || isParsingPhoneNumber
                : true
            }
            variant="contained"
            // color="secondary"
            onClick={handleFormSubmit}
          >
            {isParsingPhoneNumber ? (
              <CircularProgress size={18} sx={style.progressBtn} />
            ) : (
              "Save"
            )}
          </Button>
        </Box>
      )}
      <Dialog open={dialog.toggle} maxWidth="md">
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6" sx={{ mt: 2 }}>
              {notification?.enabled ? "Turn Off Notification?" : "Turn On Notification?"}
            </Typography>
            <IconButton onClick={toggleOnCancel}>
              <CloseIcon
                sx={{ color: "grey.600" }}
                fontSize="small"
              />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ minWidth: 432, mt: 2 }}>
          <Typography>
            {notification?.enabled
              ? `Are you sure you want to disable this notification and turn it
                 off? You will not see notifications when triggers are 
                 met for this notification.`
              : `Are you sure you want to enable this notification and turn it 
                on? You will begin to receive notifications when triggers are 
                met for this notification.`}
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginTop: "18px",
            }}
          >
            <Checkbox
              checked={preference.toggle}
              onChange={toggleOnPreferenceChange}
            />
            <Typography variant="subtitle1">
              Do not show this message again.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 5 }}>
          <Button
            onClick={toggleOnCancel}
            variant="text"
            sx={{ color: "grey.600", mr: 4 }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleToggleConfirmation}
            variant="contained"
            color="secondary"
          >
            {notification?.enabled ? "Turn Off" : "Turn On"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EditNotificationView;
